import { Component, OnInit } from '@angular/core';
import { EventsManager } from "../../events/events.manager";
import { Router } from '@angular/router';

@Component({
  selector: 'app-ancillary-benefits-detail',
  templateUrl: './ancillary-benefits-detail.component.html',
  styleUrls: ['./ancillary-benefits-detail.component.scss']
})
export class AncillaryBenefitsDetailComponent implements OnInit {
  officeData: any = {};
  template: any = {};
  ancillaryCodes: string = '';

  constructor(public em: EventsManager, private router: Router) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.officeData = this.em.officeInfo;
    
    // Get the template and ancillary codes
    const planDetailInfo = this.em.planDetailInfo;
    if (planDetailInfo && planDetailInfo.templateId) {
      this.template = this.em.officeInfo?.benefitPlanTemplates?.find((t: any) => 
        t.benefitPlanTemplateId == planDetailInfo.templateId
      );
      this.ancillaryCodes = this.template?.ancillaryBenefits || '';
    }
  }

  goBack(): void {
    this.router.navigate(['/plan-detail']);
  }
}
